import {
  axiosGetWithCookies,
  axiosPatchWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
} from './helper';
import { startOfDay, endOfDay } from 'utils/time';

export const fetchTripList = ({
  regionId,
  securityCompanyId,
  status,
  dateFrom,
  dateTo,
  businessClient,
  includeResolved,
  search,
  from,
  timezone,
}) => {
  let query = `/transport/trips?securityCompanyId=${securityCompanyId}&regionId=${regionId}&includeResolved=true&limit=50`;

  // status is always an array of objects with id and name
  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }
  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'Asia/Dili',
    });

    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timezone: timezone || 'Asia/Dili',
    });
    query += `&toDate=${endAt}`;
  }
  if (businessClient) query += `&businessClientId=${businessClient}`;
  if (includeResolved) query += `&includeResolved=${includeResolved}`;
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;

  return axiosGetWithCookies(query);
};

export const fetchTripListPdf = ({
  regionId,
  securityCompanyId,
  status,
  dateFrom,
  dateTo,
  businessClient,
  includeResolved,
  search,
  timezone,
  businessClientName,
  language,
}) => {
  let query = `/transport/trips/pdf?securityCompanyId=${securityCompanyId}&regionId=${regionId}&includeResolved=true&limit=50`;

  if (Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, c) => (acc += `&status=${c.id}`), '');
  }

  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'Asia/Dili',
    });

    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timezone: timezone || 'Asia/Dili',
    });
    query += `&toDate=${endAt}`;
  }
  if (businessClient)
    query += `&businessClientId=${businessClient}&businessClientName=${businessClientName}`;
  if (includeResolved) query += `&includeResolved=${includeResolved}`;
  if (search) query += `&search=${search}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};

export const fetchTripDetailsPdf = ({ id, timezone, language }) => {
  let query = `/transport/trips/${id}/pdf`;
  if (timezone) query += `?timezone=${timezone}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};

export const assignDriver = ({ id, driver }) => {
  return axiosPatchWithCookies(`/transport/trips/${id}/assign`, {
    data: driver,
  });
};

export const fetchTripDetail = tripId =>
  axiosGetWithCookies(`/transport/trips/${tripId}`);

export const abortTrip = id =>
  axiosPatchWithCookies(`/transport/trips/${id}/abort`);

export const getPriceRangeForServiceType = (regionId, tripType) =>
  axiosGetWithCookies(
    `/transport/trips/types/template/${regionId}/${tripType}`,
  );
export const createTransportServiceType = transportServiceData =>
  axiosPostWithCookies(`/transport/trips/types`, {
    data: transportServiceData,
  });
export const editTransportServiceType = (tripId, transportServiceData) =>
  axiosPutWithCookies(`/transport/trips/types/${tripId}`, {
    data: transportServiceData,
  });
export const fetchTripTypeDetail = tripId =>
  axiosGetWithCookies(`/transport/trips/types/${tripId}`);
